var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "confirmation_number"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3333 13.3334V8.00004C29.3333 6.52004 28.1333 5.33337 26.6667 5.33337H5.33332C3.86666 5.33337 2.67999 6.52004 2.67999 8.00004V13.3334C4.14666 13.3334 5.33332 14.5334 5.33332 16C5.33332 17.4667 4.14666 18.6667 2.66666 18.6667V24C2.66666 25.4667 3.86666 26.6667 5.33332 26.6667H26.6667C28.1333 26.6667 29.3333 25.4667 29.3333 24V18.6667C27.8667 18.6667 26.6667 17.4667 26.6667 16C26.6667 14.5334 27.8667 13.3334 29.3333 13.3334ZM26.6667 11.3867C25.08 12.3067 24 14.04 24 16C24 17.96 25.08 19.6934 26.6667 20.6134V24H5.33332V20.6134C6.91999 19.6934 7.99999 17.96 7.99999 16C7.99999 14.0267 6.93332 12.3067 5.34666 11.3867L5.33332 8.00004H26.6667V11.3867ZM14.6667 20H17.3333V22.6667H14.6667V20ZM14.6667 14.6667H17.3333V17.3334H14.6667V14.6667ZM14.6667 9.33337H17.3333V12H14.6667V9.33337Z",
    fill: "#323134"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketV2);
export default __webpack_public_path__ + "static/media/ticket-v2.e6983f0c.svg";
export { ForwardRef as ReactComponent };